export const ALERT_CATEGORY_FILTER = 'ALERT_CATEGORY_FILTER';

export const alertCategoryFilter = (alertCategoryFilter: $TSFixMe) => ({
  type: ALERT_CATEGORY_FILTER,
  alertCategoryFilter,
});
